// Managers are scoped to their own site everywhere else in the app — machines,
// checks, defects, staff all filter on `role === 'manager' && siteId`. Reports
// were the exception: they loaded the whole organisation, so promoting them to
// the main nav would have shown a site manager the entire group's figures.
//
// This keeps them consistent. Org admins are unaffected and still see
// everything; an operator never reaches reports at all.
export function scopeToSite(rows, role, siteId) {
  const list = Array.isArray(rows) ? rows : [];
  if (role !== 'manager' || !siteId) return list;
  return list.filter(r => r && r.siteId === siteId);
}
